import { useCallback, useMemo, useState } from 'react';
import Form, { Validations } from '../../../../../components/Form';
import { ControlItem } from '../../../types';
import axios from 'axios';
import { formatParam } from '../../helpers';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const RemoveSubscriptionForm = () => {
  const [userId, setUserId] = useState<string>();
  const [botId, setBotId] = useState<string | undefined>();

  const [errors, setErrors] = useState<Record<string, Validations>>({});
  const [formMessage, setFormMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const checkValidation = useCallback(() => {
    /** userId can not be empty */
    let didError;

    setErrors({});

    if (typeof userId === 'undefined') {
      setErrors((prev) => ({
        ...prev,
        userId: Validations.Required,
      }));

      didError = true;
    }

    if (typeof botId === 'undefined') {
      setErrors((prev) => ({
        ...prev,
        botId: Validations.Required,
      }));

      didError = true;
    }

    return !didError;
  }, [botId, userId]);

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);
    const canContinue = checkValidation();

    if (!canContinue) {
      return;
    }

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.RemoveSubscription,
      params: {
        userId: formatParam(userId),
        botId: formatParam(botId),
      },
    });

    setIsLoading(false);
    setFormMessage(data);
  }, [botId, checkValidation, userId]);

  const config = useMemo(() => {
    return {
      title: ControlItem.RemoveSubscription,
      formMessage,
      fields: [
        {
          label: 'User Id',
          value: userId,
          handleValueChange: setUserId,
          error: errors.userId,
        },
        {
          label: 'Bot Id',
          value: botId,
          handleValueChange: setBotId,
          error: errors.botId,
        },
      ],
      handleSubmit,
      isLoading,
    };
  }, [
    botId,
    errors.botId,
    errors.userId,
    formMessage,
    handleSubmit,
    isLoading,
    userId,
  ]);

  return <Form config={config} />;
};

export default RemoveSubscriptionForm;
